module.exports = {
  "id": "understory tutorial",
  "startingScene": 0,
  "title": "1: basics",
  "thumbnail": "/provision/projects/understory tutorial/tutorial 1 image.png",
  "category": "tutorial",
  "toolbar": {
    "glitches": [],
    "parts": []
  },
  "project_file": "understory tutorial.gbp",
  "tutorial_scripts": [
    "level1.json",
    "level2.json",
    "level3.json",
    "level4.json",
    "level5.json",
    "level6.json"
  ]
}
;